<fury-page>
    <fury-title class="title">
        <h2>{{ planTypeId ? 'Update' : 'Add'}} property plan Type</h2>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="planpropertytype" style="width: 100%;">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
            
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Title</mat-label>
                <input matInput placeholder="Title" formControlName="title">
                <mat-error
                  *ngIf="planpropertytype.controls['title'].touched && planpropertytype.controls['title'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
           </div>

           <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button"
            (click)="add()"><span>{{ planTypeId ? 'Update' : 'Add'}}</span></button>
            <button mat-button type="button" class="can-button" (click)="back()"><span>Cancel</span></button>
          </div>
  
           
          </form>
    </div>
  </div>
  
  
  
  
  
  
  
  
